import {
  Avatar,
  Breadcrumbs,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tooltip
} from '@material-ui/core';
import {grey} from '@material-ui/core/colors';
import createMuiTheme from '@material-ui/core/styles/createTheme';
import TablePagination from '@material-ui/core/TablePagination';
import {
  Add,
  ArrowBackIos,
  ArrowBackIosOutlined,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  Close,
  CloudUpload,
  DateRange,
  Description,
  Edit,
  FilterList,
  FirstPage,
  Folder,
  GetApp,
  LastPage,
  LibraryBooks,
  NavigateNext,
  PostAdd,
  SaveAlt,
  Search
} from '@material-ui/icons';
import {CsvBuilder} from 'filefy';
import MaterialTable, {MTableToolbar} from 'material-table';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import locale from '../locale/Localization';
import {
  getFolderById,
  getRootFolder,
  getVersions,
  search
} from '../script/document-service.js';
import ArchiveSearch from './ArchiveSearch';

const tableIcons = {
  Export: SaveAlt,
  Search: Search,
  Clear: Clear,
  Filter: FilterList,
  PreviousPage: ChevronLeft,
  NextPage: ChevronRight,
  FirstPage: FirstPage,
  LastPage: LastPage,
  Add: Add,
  Edit: Edit,
  Check: Check,
  Close: Close,
  SortArrow: ArrowDownward,
  ResetSearch: Close,
  DetailPanel: ChevronRight
};

const tableLocalization = {
  toolbar: {
    searchTooltip: locale.tableSearchTooltip,
    searchPlaceholder: locale.tableSearchPlaceholder
  },
  header: {
    actions: locale.tableHeaderActions
  },
  body: {
    emptyDataSourceMessage: locale.tableEmptyDataSourceMessage
  },
  pagination: {
    labelRowsPerPage: locale.tableLabelRowsPerPage,
    labelDisplayedRows: locale.tableLabelDisplayedRows,
    labelRowsSelect: locale.tableLabelRowsSelect,
    firstTooltip: locale.tableFirstTooltip,
    previousTooltip: locale.tablePreviousTooltip,
    nextTooltip: locale.tableNextTooltip,
    lastTooltip: locale.tableLastTooltip
  }
};

const theme = createMuiTheme();
const useStyles = {
  root: {marginTop: '3%', color: 'white'},
  descriptorNameColumn: {marginLeft: '-64px', width: 'max-content'},
  formControl: {margin: theme.spacing(1), width: '100%'},
  iconCell: {width: '10px', paddingBottom: '2px', paddingTop: '2px'},
  toolbar: {padding: '10px 14px'},
  select: {marginTop: 24, width: '100%'},
  paper: {padding: theme.spacing(3, 2), marginBottom: theme.spacing(0.5)},
  breadcrumbLink: {paddingBottom: '1em'},
  chipDocumentName: {border: 0, justifyContent: 'left'},
  chipNotarizedType: {backgroundColor: grey[400], width: '10em'},
  archiveSearch: {float: 'right', paddingTop: '2em'},
  button: {marginTop: '20px', color: 'white'},
  descriptorIcon: {width: '2px', height: '2px', padding: '2px'},
  gridContainer: {paddingTop: '0px', paddingBottom: '0px'},
  gridItem: {paddingTop: '0px', paddingBottom: '0px'}
};

const BREADCRUMB_ARROW_SIZE = 'small';
const ROW_BACK = locale.back;
const ROW_ROOT = locale.archive;
const TYPE_BACK = 'BACK';
const TYPE_DOCUMENT = 'DOCUMENT';
const TYPE_FOLDER = 'FOLDER';

/**
 * Component class of DocumentBrowser.
 *
 */
export default class DocumentBrowser extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    const mainArchiveAccess = Object.values(this.props.archives)[0];
    this.state = {
      children: [],
      totalResultCount: 0,
      pageSize: 10,
      pageIndex: 0,
      breadcrumbLinks: [],
      loading: false,
      rootFolderId: null,
      currentFolderId: null,
      notaryDetailsClicked: true,
      seletedRowData: null,
      anchorEl: null,
      open: false,
      archives: this.props.archives,
      mainArchiveId: mainArchiveAccess.archiveId,
      archiveId: mainArchiveAccess.archiveId,
      archiveOwner: this.props.archives[0],
      archiveAccess: mainArchiveAccess.access,
      archiveSearch: false,
      hideSearch: false,
      searchTerms: null,
      searchFolderAnchor: null,
      selectedFile: {
        versions: null
      }
    };
  }

  // eslint-disable-next-line require-jsdoc
  componentDidMount() {
    this.fetchRootFolder();
  }

  /**
   * Fetch root folder.
   *
   */
  fetchRootFolder = () => {
    getRootFolder(this.state.archiveId).then((response) => {
      this.setState({breadcrumbLinks: []});
      this.addBreadcrumbLink(response, true);
      this.setState({
        children: response.children,
        rootFolderId: response.fileId,
        currentFolderId: response.fileId,
        totalResultCount: 1,
        pageSize: 10,
        pageIndex: 0
      });
    });
  };

  /**
   * Fetch folders with given ID from backend.
   *
   * @param {Object} row - The given row.
   * @param {number} pageIndex - The given page index.
   * @param {number} pageSize - The given page size.
   */
  fetchFoldersById = (row, pageIndex, pageSize) => {
    if (this.state.archiveSearch && !this.state.hideSearch) {
      this.setState({hideSearch: true, searchFolderAnchor: row.fileId});
    }

    if (row.fileId === this.state.rootFolderId) {
      this.fetchRootFolder();
    } else {
      this.setState({loading: true});
      getFolderById(row.fileId, pageIndex, pageSize).then((response) => {
        if (
          response.fileId != this.state.rootFolderId &&
          response.fileId != this.state.searchFolderAnchor
        ) {
          const tmp = [
            {
              name: ROW_BACK,
              fileId: response.parentFolderId,
              type: TYPE_BACK
            }
          ];
          tmp.push(...response.children);

          this.setState({
            children: response.children,
            loading: false,
            pageIndex: pageIndex,
            totalResultCount: response.totalChildCount
              ? response.totalChildCount
              : this.state.totalResultCount
          });
        } else {
          this.setState({
            children: response.children,
            loading: false
          });
        }
        if (row.name === ROW_BACK) {
          this.state.breadcrumbLinks.pop();
        } else {
          this.addBreadcrumbLink(response, false);
        }
        this.setState({
          currentFolderId: response.fileId
        });
      });
    }
  };

  /**
   * Fetch navigaion items with given item from backend.
   *
   * @param {Array} item - The given item.
   */
  fetchNavigationItem = (item) => {
    const links = this.state.breadcrumbLinks;
    this.setState({
      breadcrumbLinks: links.slice(0, links.indexOf(item) + 1)
    });

    item.title === ROW_ROOT
      ? this.fetchRootFolder()
      : this.fetchFoldersById(item, 0, this.state.pageSize);
  };

  /**
   * Add new navigation link to breadcrumb.
   *
   * @param {Response} response - Response of service call.
   * @param {boolean} root - Determine if the link is root.
   */
  addBreadcrumbLink = (response, root) => {
    const links = this.state.breadcrumbLinks;
    const title = root ? ROW_ROOT : response.name;

    if (!links.some((links) => links.fileId === response.fileId)) {
      this.state.breadcrumbLinks.push({
        title: title,
        fileId: response.fileId
      });
    }
  };

  /**
   * Generate the breadcrumb navigation for the file browser.
   *
   * @return {string} - The navigation content.
   */
  getBreadcrumbNavigation = () => {
    return (
      <div>
        {this.state.breadcrumbLinks.map((item, key) => {
          return (
            <span key={key}>
              <Link
                color='inherit'
                component='button'
                variant='body2'
                onClick={() => {
                  this.fetchNavigationItem(item);
                }}
                style={useStyles.breadcrumbLink}
              >
                {item.title}
              </Link>
              {this.state.breadcrumbLinks.length - 1 > key && (
                <NavigateNext fontSize={BREADCRUMB_ARROW_SIZE} />
              )}
            </span>
          );
        })}
      </div>
    );
  };

  /**
   * Render actions for material table rows.
   *
   * @param {Object} row - Current row for which actions to be rendered.
   * @return {string} - The actions for each row.
   */
  renderActions = (row) => {
    switch (row.type) {
      case TYPE_BACK:
        return false;
      case TYPE_DOCUMENT:
        return {
          icon: GetApp,
          tooltip: locale.documentBrowserActionDownloadDocument,
          onClick: () =>
            window.open('/documents/' + row.fileId + '/content', '_blank')
        };
      case TYPE_FOLDER:
        return false;
      default:
        return false;
    }
  };

  /**
   * Refreshs folder
   */
  refresh = () => {
    this.fetchFoldersById({
      fileId: this.state.currentFolderId,
      pageIndex: this.state.pageIndex,
      pageSize: this.state.pageSize
    });
  };

  /**
   * Function to display the document upload.
   *
   */
  displayDocumentUpload = () => {
    this.setState({
      open: true
    });
    this.props.onDocumentUploadShown();
  };

  /**
   * Renders document upload button.
   *
   * @return {string} - The button to be rendered.
   */
  renderDocumentUploadButton = () => {
    return (
      <div>
        {this.state.currentFolderId === this.state.rootFolderId &&
          this.state.archiveAccess === 'WRITE' && (
            <Button
              variant='contained'
              color='default'
              size='small'
              startIcon={<CloudUpload />}
              onClick={() => this.displayDocumentUpload()}
            >
              {locale.uploadButton}
            </Button>
          )}
      </div>
    );
  };

  /**
   * Render the row depending on document type.
   *
   * @param {Object} row - The row data of the column.
   * @return {string} - The row to render.
   */
  renderIconRow = (row) => {
    switch (row.type) {
      case TYPE_BACK:
        return <ArrowBackIos color='disabled' />;
      case TYPE_DOCUMENT:
        return row.legacy ? (
          <DateRange color='disabled' />
        ) : (
          <Description color='disabled' />
        );
      case TYPE_FOLDER:
        return <Folder color='disabled' />;
      default:
        return null;
    }
  };
  /**
   * Render the row depending on document type.
   *
   * @param {Object} rowData - The row data of the column.
   * @return {string} - The row to render.
   */
  renderNameRow = (rowData) => {
    if (
      rowData.type === TYPE_DOCUMENT &&
      !rowData.legacy &&
      this.state.currentFolderId === this.state.rootFolderId
    ) {
      return (
        <Tooltip
          title={rowData.documentNumber ? rowData.documentNumber : ''}
          placement='top'
        >
          <Chip
            avatar={
              <Tooltip
                title={
                  rowData.contract ? locale.getString(rowData.contract) : ''
                }
                placement='left'
              >
                <Avatar>
                  {rowData.contract
                    ? locale.getString('tableColumn' + rowData.contract)
                    : ''}
                </Avatar>
              </Tooltip>
            }
            variant='outlined'
            size='small'
            style={useStyles.chipDocumentName}
            label={rowData.documentNumber}
          />
        </Tooltip>
      );
    } else if (rowData.type === TYPE_DOCUMENT && rowData.legacy) {
      return (
        <Tooltip title={rowData.name ? rowData.name : ''} placement='top'>
          <Chip
            variant='outlined'
            size='small'
            style={useStyles.chipDocumentName}
            label={'(' + rowData.documentNumber + ') ' + rowData.name}
          />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={rowData.name ? rowData.name : ''} placement='top'>
          <Chip
            variant='outlined'
            size='small'
            style={useStyles.chipDocumentName}
            label={rowData.name}
          />
        </Tooltip>
      );
    }
  };

  /**
   * Render the row depending on document type.
   *
   * @param {Object} rowData - The row data of the column.
   * @return {string} - The row to render.
   */
  renderTypeRow = (rowData) => {
    if (rowData.type === TYPE_DOCUMENT && rowData.notarizedType) {
      return (
        <Tooltip
          title={locale.getString(rowData.notarizedType)}
          placement='top'
        >
          <Chip
            variant='outlined'
            size='small'
            style={useStyles.chipNotarizedType}
            label={locale.getString(rowData.notarizedType)}
          />
        </Tooltip>
      );
    }
  };

  /**
   * Render the row depending on document type.
   *
   * @param {Object} rowData - The row data of the column.
   * @return {string} - The row to render.
   */
  renderLegalEntityRow = (rowData) => {
    if (rowData.type === TYPE_DOCUMENT && rowData.notarizedObject) {
      return (
        <Tooltip title={rowData.notarizedObject} placement='top'>
          <Chip
            variant='outlined'
            size='small'
            style={useStyles.chipNotarizedType}
            label={rowData.notarizedObject}
          />
        </Tooltip>
      );
    }
  };

  /**
   * Handles click event on document's version action.
   *
   * @param {Event} event - The action click event.
   * @param {Object} rowData - The table row data.
   */
  handleDocumentVersionsActionClick = (event, rowData) => {
    getVersions(rowData.fileId).then((result) => {
      this.setState({
        selectedFile: {versions: result}
      });
    });

    this.setState({
      anchorEl: event.currentTarget,
      open: true
    });
  };

  /**
   * Handles closing of document's version menu.
   */
  handleDocumentVersionsMenuClose = () => {
    this.setState({
      anchorEl: null,
      open: false,
      selectedFile: {versions: null}
    });
  };

  /**
   * Downloads document's version.
   *
   * @param {Object} e - click event object.
   */
  downloadDocumentVersion = (e) => {
    const docIdParts = e.target.id.split(';');
    window.open(
      '/documents/' + docIdParts[0] + '/' + docIdParts[1] + '/content',
      '_blank'
    );
  };

  /**
   * Renders document versions menu.
   *
   * @return {string} - menu containing document versions.
   */
  renderDocumentVersionsMenu = () => {
    const menuItems = [];
    this.state.selectedFile.versions.forEach((value) => {
      const versionIdParts = value.id.split(';');
      menuItems.push(
        <MenuItem id={value.id} onClick={this.downloadDocumentVersion}>
          {'v ' + versionIdParts[1]}
        </MenuItem>
      );
    });
    return (
      <Menu
        id='document-versions-menu'
        anchorEl={this.state.anchorEl}
        keepMounted
        open={this.state.open}
        onClose={this.handleDocumentVersionsMenuClose}
      >
        {menuItems}
      </Menu>
    );
  };

  /**
   * Handle the select archive event from archive input.
   *
   * @param {Object} event
   */
  handleSelectArchive = async (event) => {
    const archiveId = Number(event.target.value);
    this.props.onSelectArchive(archiveId);
    const access = this.state.archives.find((ac) => ac.archiveId === archiveId);
    await this.setState({
      archiveId: archiveId,
      archiveOwner: access.archiveName,
      archiveAccess: access.access
    });
    this.fetchRootFolder();
  };

  /**
   * Renders archive selector.
   *
   * @return {string} - The archive selector component.
   */
  renderArchiveSelector = () => {
    // Warning is only visible when archive is switched
    const isForeignArchive = !(
      this.state.mainArchiveId == this.state.archiveId
    );
    return (
      <FormControl style={useStyles.formControl} error={isForeignArchive}>
        <InputLabel htmlFor='archive'>{locale.archive}</InputLabel>
        <Select
          native
          onChange={(event) => this.handleSelectArchive(event)}
          style={useStyles.select}
          value={this.state.archiveId}
        >
          {this.state.archives.map((access, key) => {
            return (
              <option key={key} value={access.archiveId}>
                {access.archiveName}
              </option>
            );
          })}
        </Select>
        <FormHelperText>
          {isForeignArchive ? locale.foreignArchiveWarning : ''}
        </FormHelperText>
      </FormControl>
    );
  };

  /**
   * React subrender function for the table toolbar.
   *
   * @param {Object} props - The table props.
   * @param {string} breadcrumbNavigation - The breadcrumb component.
   * @return {string} - The material table toolbar.
   */
  renderTableToolbar = (props, breadcrumbNavigation) => {
    return (
      <>
        <MTableToolbar {...props} />
        <Grid container item xs={12} spacing={3} style={useStyles.toolbar}>
          <Grid item xs={6}>
            {!this.state.archiveSearch && (
              <Breadcrumbs aria-label='breadcrumb'>
                {breadcrumbNavigation}
              </Breadcrumbs>
            )}
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={2}>
            {this.renderDocumentUploadButton()}
          </Grid>
        </Grid>
      </>
    );
  };

  /**
   * Handles the archive search.
   *
   * @param {Array} searchTerms - The search term.
   */
  handleArchiveSearchSubmit = (searchTerms) => {
    this.setState({searchTerms: searchTerms});
    if (searchTerms.length > 0) {
      this.searchSubmit(searchTerms, 0, this.state.pageSize);
    } else {
      this.setState({archiveSearch: false});
      this.fetchRootFolder();
    }
  };

  /**
   * Handles search submit
   *
   * @param {Array} searchTerms - The search term.
   * @param {number} pageIndex - The page index.
   * @param {number} pageSize - The selected row per page size.
   */
  searchSubmit = (searchTerms, pageIndex, pageSize) => {
    searchTerms = searchTerms.map((option) => {
      if (!(option instanceof Object)) {
        return {label: option, group: 'name', value: option};
      } else {
        return option;
      }
    });

    this.setState({loading: true});
    this.setState({currentFolderId: this.state.rootFolderId});
    search(
      this.state.archiveId,
      {terms: searchTerms},
      pageIndex,
      pageSize
    ).then((response) => {
      const children = response.files;
      this.setState({
        children: children,
        loading: false,
        archiveSearch: true,
        pageIndex: pageIndex,
        totalResultCount: response.totalResultCount
      });
    });
  };

  /**
   * Gets all search results for csv export.
   */
  getAllSearchResults = async () => {
    const searchTerms = this.state.searchTerms.map((option) => {
      if (!(option instanceof Object)) {
        return {label: option, group: 'name', value: option};
      } else {
        return option;
      }
    });

    return search(this.state.archiveId, {terms: searchTerms}).then(
      (response) => response.files
    );
  };

  /**
   * Render archive search component.
   *
   * @return {string} - The archive search component.
   */
  renderArchiveSearch = () => {
    return (
      <ArchiveSearch
        onSearchSubmit={this.handleArchiveSearchSubmit}
        useStyle={useStyles.archiveSearch}
      />
    );
  };

  /**
   * Renders the archive user action row above the document browser.
   *
   * @return {string} - The components to be rendered.
   */
  renderArchiveActionRow = () => {
    return (
      <Paper style={useStyles.paper} hidden={this.state.hideSearch}>
        <Grid
          id='archive-action-row'
          container
          spacing={3}
          style={useStyles.gridContainer}
        >
          <Grid item xs={5} style={useStyles.gridItem}>
            {this.renderArchiveSelector()}
          </Grid>
          <Grid item xs={12} style={useStyles.gridItem}>
            {this.renderArchiveSearch()}
          </Grid>
        </Grid>
      </Paper>
    );
  };

  /**
   * Renders the search back view.
   *
   * @return {string} - The components to be rendered.
   */
  renderBackButton = () => {
    return (
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={10}>
          <Button
            style={useStyles.button}
            size='small'
            onClick={() => {
              this.setState({hideSearch: false, searchFolderAnchor: null});
              this.handleArchiveSearchSubmit(this.state.searchTerms);
            }}
            startIcon={<ArrowBackIosOutlined />}
          >
            {locale.backToSearch}
          </Button>
        </Grid>
      </Grid>
    );
  };

  /**
   * Handles the page change of the document table.
   *
   * @param {number} pageIndex - The selected page index.
   */
  handleChangePage = (pageIndex) => {
    this.setState({pageIndex: pageIndex});
    this.handleTablePaginationChange(pageIndex, this.state.pageSize);
  };

  /**
   * Handles the row per page change of the document table.
   *
   * @param {number} pageSize - The selected row per page size.
   */
  handleChangeRowPerPage = (pageSize) => {
    this.setState({
      pageSize: pageSize,
      pageIndex: 0
    });
    this.handleTablePaginationChange(0, pageSize);
  };

  /**
   * Handles the change of the table pagination events.
   *
   * @param {number} pageIndex - The selected page index.
   * @param {number} pageSize - The selected row per page size.
   */
  handleTablePaginationChange = (pageIndex, pageSize) => {
    if (this.state.searchTerms && this.state.searchTerms.length > 0) {
      this.searchSubmit(this.state.searchTerms, pageIndex, pageSize);
    } else {
      this.setState({archiveSearch: false});
      const row = {fileId: this.state.currentFolderId};
      this.fetchFoldersById(row, pageIndex, pageSize);
    }
  };

  /**
   * React render function.
   *
   * @return {string} - The component contents.
   */
  // eslint-disable-next-line max-lines-per-function, require-jsdoc
  render() {
    const breadcrumbNavigation = this.getBreadcrumbNavigation();

    return (
      <React.Fragment>
        {this.state.hideSearch && this.renderBackButton()}

        <div style={useStyles.root}>
          <h1>{locale.documentBrowserTitle}</h1>
          {this.renderArchiveActionRow()}
          <MaterialTable
            icons={tableIcons}
            localization={tableLocalization}
            columns={[
              {
                cellStyle: useStyles.iconCell,
                render: this.renderIconRow
              },
              {
                title: locale.name,
                field: 'documentNumber',
                render: this.renderNameRow
              },
              {
                title: locale.notarizedObjectHeader,
                field: 'notarizedObject',
                render: this.renderLegalEntityRow
              },
              {
                title: locale.notarizedType,
                field: 'notarizedType',
                render: this.renderTypeRow,
                export: false
              },
              {
                title: locale.documentBrowserColumnLastModificationDate,
                field: 'lastModificationDate',
                type: 'date'
              }
            ]}
            isLoading={this.state.loading}
            data={this.state.children}
            options={{
              actionsColumnIndex: -1,
              search: false,
              showTitle: true,
              sorting: false,
              exportButton: {
                csv: true,
                pdf: false
              },
              exportCsv: async (columns, data) => {
                const csvColumns = [
                  locale.documentNumber,
                  locale.notarizedObject,
                  locale.notarizedType,
                  locale.documentBrowserColumnLastModificationDate,
                  locale.createDate,
                  locale.legacyDocument
                ];

                const csvRows = [];
                const csvData = this.state.archiveSearch
                  ? await this.getAllSearchResults()
                  : data;
                csvData.forEach((value) => {
                  if (value.type === TYPE_DOCUMENT) {
                    const row = [
                      value.documentNumber,
                      value.notarizedObject,
                      locale.getString(value.notarizedType),
                      value.lastModificationDate,
                      value.creationDate,
                      value.legacy ? 'X' : ''
                    ];
                    csvRows.push(row);
                  }
                });
                const currentDate = moment().format(locale.dateFormat);
                const fileName = locale.formatString(
                  locale.exportFileName,
                  currentDate
                );
                new CsvBuilder(fileName)
                  .setColumns(csvColumns)
                  .addRows(csvRows)
                  .exportFile();
              },
              pageSize: this.state.pageSize,
              cellStyle: this.getCellStyle,
              rowStyle: this.getRowStyle
            }}
            title={locale.documentBrowserTitle}
            components={{
              Toolbar: (props) =>
                this.renderTableToolbar(props, breadcrumbNavigation),
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[10, 20, 30]}
                  rowsPerPage={this.state.pageSize}
                  count={this.state.totalResultCount}
                  page={this.state.pageIndex}
                  onChangePage={(event, newPage) => {
                    this.handleChangePage(newPage);
                  }}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    this.handleChangeRowPerPage(event.target.value);
                  }}
                />
              )
            }}
            onRowClick={(event, row) => {
              if (row.type === TYPE_DOCUMENT) {
                return this.props.onDocumentDetailsShown(
                  row,
                  this.state.archiveAccess
                );
              } else if (row.type === TYPE_FOLDER || row.type === TYPE_BACK) {
                return this.fetchFoldersById(row, 0, this.state.pageSize);
              }
            }}
            actions={[
              (rowData) => ({
                icon: GetApp,
                tooltip: locale.documentBrowserActionDownloadDocument,
                onClick: (event, rowData) =>
                  window.open(
                    '/documents/' + rowData.fileId + '/content',
                    '_blank'
                  ),
                hidden: rowData.type != TYPE_DOCUMENT
              }),
              (rowData) => ({
                icon: PostAdd,
                tooltip: locale.documentBrowserActionAddNewVersion,
                onClick: (event, rowData) => {
                  this.props.onDocumentNewVersionUploadShown(rowData.fileId);
                },
                hidden:
                  rowData.type !== TYPE_DOCUMENT ||
                  this.state.archiveAccess === 'READ'
              }),
              (rowData) => ({
                icon: LibraryBooks,
                tooltip: locale.documentBrowserActionAllVersions,
                onClick: (event, rowData) => {
                  this.handleDocumentVersionsActionClick(event, rowData);
                },
                hidden: rowData.type != TYPE_DOCUMENT
              })
            ]}
          />
          {this.state.selectedFile.versions &&
            this.renderDocumentVersionsMenu()}
        </div>
      </React.Fragment>
    );
  }
}

DocumentBrowser.propTypes = {
  archives: PropTypes.array.isRequired,
  onDocumentDetailsShown: PropTypes.func.isRequired,
  onDocumentUploadShown: PropTypes.func.isRequired,
  onSelectArchive: PropTypes.func.isRequired,
  onDocumentNewVersionUploadShown: PropTypes.func.isRequired
};
